import { DataProvider } from 'react-admin'
import { NotificationTagDto } from '../../dto/system-notifications/notification-tag.dto'

const fakeTags: NotificationTagDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeTags, total: fakeTags.length }),
} as DataProvider

export default provider
